<template>
  <div class="bot-wrapper">
    <div class="messages-box" v-if="this.isGold && open">
      <div class="chat-header">
        <div class="logo">
          <img src="/logo-bot.svg" width="100%" alt="">
        </div>
        <div class="info">
          <div class="title">iTenderAI</div>
          <div class="description">Գնումների իրավական AI խորհրդատու (24/7)</div>
        </div>
        <div class="tools">
          <div class="close-wrap" @click="open = false">
            <img width="100%" src="/assets/landing/images/closeModal.svg" alt="">
          </div>
        </div>
      </div>
      <div class="messages little-scroll"
           ref="messagesBlock"
      >

        <div class="chat-info-wrapper" v-if="!messages.length">

          <p class="text">
            Բարև 👋
            <br>
            Ես iTender AI գնումների իրավական խորհրդատուն եմ։
            <br>
            <br>
            Կօգնեմ ձեզ հասկանալ և ճիշտ կիրառել գնումների օրենսդրությունը՝
          </p>
          <ul class="list-options">
            <li class="option">մասնակցության պահանջներ և սահմանափակումներ</li>
            <li class="option">որակավորման և մերժման հիմքեր</li>
            <li class="option">բողոքարկման կարգ և ընթացակարգեր</li>
            <li class="option">պայմանագրերի կնքում և կատարում</li>
          </ul>
          <p class="text">
            <br>
            Ստացեք հստակ և կիրառելի պատասխաններ ձեր հարցերին։
            <br>
            <br>
            Գրեք ձեր հարցը։
          </p>
        </div>
        <div
          class="msg"
          :class="message.sender === 'bot' ? 'bot' : 'client'"
          v-for="(message, index) in messages"
          :key="index"
        >
          <template v-if="message.sender === 'bot'">
            <div class="sender-info">
              <div class="logo-wrap">
                <img src="/logo-bot.svg" width="100%" alt="">
              </div>
              <div class="name">{{ message.senderName || 'iTenderAI' }}</div>
            </div>
          </template>

          <div class="text" v-html="nlToBr(message.message)"></div>
        </div>
        <div v-if="loading" class="circle-box">
          <div class="circle"></div><div class="circle"></div><div class="circle"></div>
        </div>
      </div>
      <div class="input-wrapper">
        <div class="input-form">
          <textarea
            type="text"
            class="message-inp little-scroll"
            placeholder="Ունե՞ք հարց գնումների մասին — գրեք այստեղ"
            rows="1"
            :disabled="loading"
            v-model="message"
            @input="resize"
            ref="textarea"
          ></textarea>
          <div class="send-btn" @click="sendMessage">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.9709 9.21918C18.8292 8.97751 18.6209 8.76918 18.3792 8.63584H18.3709L5.24589 1.13584C4.49589 0.719176 3.53756 0.985843 3.12089 1.73584C2.89589 2.12751 2.86256 2.59418 3.00422 3.01918L5.36256 10.0025L3.00422 16.9858C2.72089 17.7942 3.14589 18.6858 3.96256 18.9775C4.12922 19.0358 4.30422 19.0608 4.47922 19.0608C4.74589 19.0608 5.01256 18.9942 5.24589 18.8608H5.25422L18.3792 11.3525C19.1292 10.9275 19.3959 9.96918 18.9709 9.21918ZM5.03756 16.8192L7.02922 10.9358H11.3542V9.06084H7.02922L5.03756 3.18584L16.9709 9.99418L5.03756 16.8192Z" fill="#6E7485"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="bot-icon" :class="{'open': open}" @click="openChat()">
      <div class="img-wrapper">
        <img v-if="open" width="100%" src="/assets/landing/images/closeModal.svg" alt="">
        <img v-else width="100%" src="/logo-bot.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      open: false,
      message: '',
      loading: false,
    }
  },
  computed: {
    messages() {
      return this.$store.getters['chatBot/messages']
    },
    isGold() {
      return this.$store.getters['user/isGold']
    },
  },
  methods: {
    openChat() {
      if (!this.isGold) {
        this.$fire({
          text: "Հասանելի է Գոլդ փաթեթի օգտատերերին",
          type: "info",
          confirmButtonText: 'Լավ'
        })
        return;
      }
      this.open = !this.open
    },
    nlToBr(rawText) {
        if (!rawText) {
          return ''
        }
        return rawText.replace(/\n/g, '<br />');
    },
    async sendMessage() {
      // validate
      if (!this.message.length || this.loading) {
        return;
      }

      // loading
      this.loading = true
      this.scrollToBottom()
      const message = this.message;
      this.message = '';

      // request
      await this.$store.dispatch('chatBot/sendMessage', message)

      // reset
      this.loading = false
      this.scrollToBottom()
      setTimeout(this.resize, 100)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.messagesBlock;
        el.scrollTop = el.scrollHeight;
      });
    },
    resize() {
      const el = this.$refs.textarea;
      el.style.height = 'auto';
      el.style.height = (el.scrollHeight) + 'px';
    }
  }
}
</script>
